/**
 * VIVI product-card media gallery � snap scroll + dots.
 * Only mounts on [data-vivi-card-gallery]; horizontal rails omit that attribute.
 */
(function () {
  if (window.ViviCardGallery) return;

  function updateDots(root) {
    var gallery = root.querySelector('[data-vivi-card-gallery-track]');
    var dots = root.querySelectorAll('[data-vivi-card-dot]');
    if (!gallery || !dots.length) return;

    var slideW = gallery.clientWidth || 1;
    var index = Math.round(gallery.scrollLeft / slideW);
    if (index < 0) index = 0;
    if (index > dots.length - 1) index = dots.length - 1;

    dots.forEach(function (dot, i) {
      dot.classList.toggle('is-active', i === index);
    });
  }

  function bind(root) {
    if (root.dataset.viviGalleryBound === '1') return;
    var gallery = root.querySelector('[data-vivi-card-gallery-track]');
    if (!gallery) return;
    root.dataset.viviGalleryBound = '1';

    var ticking = false;
    var onScroll = function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        updateDots(root);
        ticking = false;
      });
    };

    gallery.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(onScroll).observe(gallery);
    }
    updateDots(root);
  }

  function scan(scope) {
    (scope || document)
      .querySelectorAll('[data-vivi-card-gallery]:not([data-vivi-gallery-bound="1"])')
      .forEach(bind);
  }

  window.ViviCardGallery = { scan: scan, updateDots: updateDots };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan(document);
    });
  } else {
    scan(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target || document);
  });
})();

/**
 * VIVI card hover image — secondary card images ship without src/srcset
 * (data-vivi-src / data-vivi-srcset). Hydrate only on mouse devices as cards
 * near the viewport, or on keyboard focus. Touch devices never download them.
 */
(function () {
  if (window.ViviCardHover) return;

  var SEL = 'img[data-vivi-srcset], img[data-vivi-src]';
  var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var io = null;

  function hydrate(img) {
    var srcset = img.getAttribute('data-vivi-srcset');
    var src = img.getAttribute('data-vivi-src');
    if (srcset) img.setAttribute('srcset', srcset);
    if (src) img.setAttribute('src', src);
    img.removeAttribute('data-vivi-srcset');
    img.removeAttribute('data-vivi-src');
  }

  if (canHover && 'IntersectionObserver' in window) {
    io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          io.unobserve(entry.target);
          hydrate(entry.target);
        });
      },
      { rootMargin: '300px' }
    );
  }

  function scan(scope) {
    var imgs = (scope || document).querySelectorAll(SEL);
    imgs.forEach(function (img) {
      if (io) io.observe(img);
      else if (canHover) hydrate(img);
    });
  }

  function hydrateWithin(target) {
    var link = target && target.closest ? target.closest('.vivi-card__media-link') : null;
    if (!link) return;
    var img = link.querySelector(SEL);
    if (img) hydrate(img);
  }

  document.addEventListener('focusin', function (e) {
    hydrateWithin(e.target);
  });
  if (canHover) {
    document.addEventListener('mouseover', function (e) {
      hydrateWithin(e.target);
    });
  }

  window.ViviCardHover = { scan: scan };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan(document);
    });
  } else {
    scan(document);
  }

  // Cards injected later (filters, deferred homepage rails, section reloads)
  if (canHover && typeof MutationObserver !== 'undefined') {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches(SEL)) scan(node.parentNode);
          else if (node.querySelector && node.querySelector(SEL)) scan(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
